import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable } from 'immer';

import dayjs from '../../../../core/configs/dayjs';

export type SelectedConsumer = {
	id: number;
	name: string;
	isGroup: boolean;
	avatar: AvatarEntity | null;
};

interface IConsumerItem {
	id: number;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
	login: string;
	firstName: string;
	lastName: string;
	mail: string;
	avatar: AvatarEntity | null;
	name: string;
	description: string;
	isGroup: boolean;
}

type UserConsumer = Omit<IConsumerItem, 'description'>;

type GroupConsumer = {
	id: number;
	name: string;
	description: string;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
	isGroup: boolean;
};

const entityDefaults: IConsumerItem = {
	id: -1,
	creationDate: null,
	updateDate: null,
	login: '',
	firstName: '',
	lastName: '',
	mail: '',
	avatar: null,
	name: '',
	description: '',
	isGroup: false,
};

export class AccessConsumerItemEntity implements IConsumerItem {
	private [immerable] = true;

	public id = entityDefaults.id;
	public avatar = entityDefaults.avatar;
	public creationDate = entityDefaults.creationDate;
	public updateDate = entityDefaults.updateDate;
	public login = entityDefaults.login;
	public firstName = entityDefaults.firstName;
	public lastName = entityDefaults.lastName;
	public mail = entityDefaults.mail;
	public name = entityDefaults.name;
	public description = entityDefaults.description;
	public isGroup = entityDefaults.isGroup;

	public static buildConsumer(
		params: Partial<IConsumerItem>
	): AccessConsumerItemEntity {
		if (params.isGroup) {
			return this.buildGroupConsumer(params);
		}
		return this.buildUserConsumer(params);
	}
	private static buildUserConsumer(
		params: Partial<UserConsumer>
	): AccessConsumerItemEntity {
		return new AccessConsumerItemEntity({
			id: params.id,
			login: params.login,
			firstName: params.firstName,
			lastName: params.lastName,
			name: params.name,
			mail: params.mail,
			creationDate: params.creationDate,
			updateDate: params.updateDate,
			isGroup: false,
		});
	}
	private static buildGroupConsumer(
		params: Partial<GroupConsumer>
	): AccessConsumerItemEntity {
		return new AccessConsumerItemEntity({
			id: params.id,
			name: params.name,
			description: params.description,
			creationDate: params.creationDate,
			updateDate: params.updateDate,
			isGroup: true,
		});
	}
	private constructor(params: Partial<IConsumerItem>) {
		this.id = params.id ?? entityDefaults.id;
		this.login = params.login ?? entityDefaults.login;
		this.firstName = params.firstName ?? entityDefaults.firstName;
		this.lastName = params.lastName ?? entityDefaults.lastName;
		this.mail = params.mail ?? entityDefaults.mail;
		this.name = params.name ?? entityDefaults.name;
		this.description = params.description ?? entityDefaults.description;
		this.creationDate = params.creationDate ?? entityDefaults.creationDate;
		this.updateDate = params.updateDate ?? entityDefaults.updateDate;
		this.isGroup = params.isGroup ?? entityDefaults.isGroup;

		this.avatar = params.login
			? AvatarEntity.build(params.login)
			: AvatarEntity.build(`${params.firstName} ${params.lastName}`);
	}
}
